"use strict";

window.ut = window.ut || [];

var clickEvent = function (group, id) {
    window.ut.push(["gtm", "set", { linkgroup: group, linkid: id }]);
};

var addCustomDimension = function(index, value) {
  var dimension = {};
  dimension["test_experiments.tt" + index] = value;
  window.ut.push(["gtm", "set", dimension]);
};

var publishTrackingInfo = function(pageId) {
    var el = document.getElementById("js-data");

    if(el){
        window.ut.push(["pagename", {
            attribute: "",
            category: "all",
            country: el.getAttribute("data-country"),
            language: el.getAttribute("data-language"),
            group: "",
            layer: "",
            market: "all",
            environment: (document.location.host.indexOf("dev-") === 0 ? "test" : el.getAttribute("data-tracking-environment")),
            pageid: pageId || "home",
            techState: "tatsu"
        }]);

        if (el.dataset.country === 'AT' && /home-feed-bucket=cohort_oldhome_de-at/.test(document.cookie)) {
            window.ut.push(['gtm', 'set', {'homefeed': 'cohort_home_at'}]);
        }

        window.ut.push(["gtm", "pageview"]);
    }
};

module.exports = {
    clickEvent: clickEvent,
    publishTrackingInfo: publishTrackingInfo,
    addCustomDimension: addCustomDimension
};
